import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Copyright from "../../internals/components/Copyright";
import AgentList from "./AgentList";
import { getMerchants } from "../../actions/merchant";
import { useNavigate } from "react-router";
import AddUpdateAgent from "../dialogs/AddUpdateAgent";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "50px",
	width: "200px",
	textTransform: "capitalize",
	marginLeft: 2,
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const MainAgentsList = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	const [agent, setAgent] = useState({});
	const [agents, setAgents] = useState([]);
	const [merchants, setMerchants] = useState([]);
	const [edit, setEdit] = useState(false);
	const navigate = useNavigate();
	const [addUpdateAgentDialog, setAddUpdateAgentDialog] = useState({
		isOpen: false,
		title: "",
	});

	useEffect(() => {
		getMerchants(token, (res) => {
			if (!res.error) {
				setMerchants(res.data);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
		if (agent.id) {
			document.getElementById("activeAgent").focus();
		}
	}, []);

	const addAgent = (e) => {
		e.preventDefault();
		setAddUpdateAgentDialog({ ...addUpdateAgentDialog, isOpen: true, title: "Add Agent" });
	};

	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Agents List
			</Typography>
			<Box
				sx={{
					alignItems: "left",
					alignContent: "left",
					textAlign: "left",
					width: "100%",
					paddingBottom: 4,
					paddingTop: 2,
				}}
			>
				<Button size="small" variant="extended" sx={styleButton} onClick={addAgent}>
					{"ADD AGENT"}
				</Button>
			</Box>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<AgentList
						token={token}
						setAgents={setAgents}
						setEdit={setEdit}
						setAgent={setAgent}
						setAddUpdateAgentDialog={setAddUpdateAgentDialog}
						addUpdateAgentDialog={addUpdateAgentDialog}
					/>
				</Grid>
				<AddUpdateAgent
					token={token}
					addUpdateAgentDialog={addUpdateAgentDialog}
					agent={agent}
					setAgent={setAgent}
					agents={agents}
					merchants={merchants}
					edit={edit}
					setEdit={setEdit}
					setAddUpdateAgentDialog={setAddUpdateAgentDialog}
				/>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default MainAgentsList;
